module.exports = __webpack_public_path__ + "static/media/Face_404@3x.51297758.png";